var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { findSelectedSection, findSelectedTableCell, findSelectionAnchorNode, selectionHasMark } from '@intercom/embercom-prosemirror-composer/lib/helpers/selection';
import { TextSelection, NodeSelection, AllSelection } from 'prosemirror-state';
import { undoDepth, redoDepth } from 'prosemirror-history';
import { tracked } from '@glimmer/tracking';
import { selectionInfo } from '../helpers/selection';
import { hoverInfo, hoverInfoHasData } from '../helpers/hover';
import { ALIGNMENTS } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import { centerablesInSelection, dominantAlignment } from '../helpers/center';
import { findParentNodeOfType, findTable, isCellSelection } from 'prosemirror-utils';
import { POPOVER_CONTAINER_CLASS } from '@intercom/embercom-prosemirror-composer/components/utils/popover';
let State = (_class = class State {
  constructor(editorView, config, uploadManager) {
    _initializerDefineProperty(this, "prosemirrorState", _descriptor, this);
    _initializerDefineProperty(this, "editorView", _descriptor2, this);
    _initializerDefineProperty(this, "selectionInfo", _descriptor3, this);
    _initializerDefineProperty(this, "hoverInfo", _descriptor4, this);
    _initializerDefineProperty(this, "mouseIsDown", _descriptor5, this);
    _initializerDefineProperty(this, "isEditing", _descriptor6, this);
    _initializerDefineProperty(this, "isInteractive", _descriptor7, this);
    _initializerDefineProperty(this, "isFormattable", _descriptor8, this);
    _initializerDefineProperty(this, "isSectionSelected", _descriptor9, this);
    _initializerDefineProperty(this, "showSectionType", _descriptor0, this);
    _defineProperty(this, "isDestroying", false);
    _initializerDefineProperty(this, "typeaheadState", _descriptor1, this);
    _defineProperty(this, "uploadManager", void 0);
    _defineProperty(this, "config", void 0);
    this.prosemirrorState = editorView.state;
    this.editorView = editorView;
    this.config = config;
    this.uploadManager = uploadManager;
  }
  set(newState) {
    this.prosemirrorState = newState;
  }
  resolveNode(element) {
    let pos = this.editorView.posAtDOM(element, 0);
    let resolvedPos = this.editorView.state.doc.resolve(pos);
    return resolvedPos.node(resolvedPos.depth);
  }
  updateSelectionInfo(editorView) {
    if (!this.isInteractive) {
      return;
    }
    this.selectionInfo = selectionInfo(editorView);
  }
  updateHoverInfo(e, editorView, composerIdentifier) {
    if (!this.isInteractive || e.target.closest(`.${POPOVER_CONTAINER_CLASS}`)) {
      return;
    }
    let info = hoverInfo(e, editorView, composerIdentifier);
    if (this.config?.experimental?.hideInsertersOnMouseOut || !this.config?.experimental?.hideInsertersOnMouseOut && hoverInfoHasData(info)) {
      this.hoverInfo = info;
    }
  }
  updateTypeaheadState(editorView) {
    if (this.prosemirrorState.selection.from !== this.prosemirrorState.selection.to) {
      this.typeaheadState = {};
      return;
    }
    this.config.typeaheads?.forEach(t => {
      let match = t.matcher(this.prosemirrorState.selection.$from, editorView);
      if (match) {
        this.typeaheadState[t.name] = match;
      } else {
        delete this.typeaheadState[t.name];
      }
    });
    /* eslint-disable-next-line no-self-assign */
    this.typeaheadState = this.typeaheadState;
  }
  get nearestInsertionPointToCursor() {
    let $pos = this.prosemirrorState.selection.$from;
    let before = $pos.before(1);
    let after = $pos.after(1);
    let distanceToBefore = $pos.pos - before;
    let distanceToAfter = after - $pos.pos;
    if (distanceToBefore < distanceToAfter) {
      return before;
    }
    return after;
  }
  get hasContent() {
    let docContent = this.prosemirrorState.doc.content;
    if (docContent.childCount > 1) {
      return true;
    }
    if (docContent.firstChild) {
      return docContent.firstChild.type !== this.prosemirrorState.schema.nodes.paragraph || docContent.firstChild.childCount > 0 || docContent.firstChild.textContent !== '';
    }
    return false;
  }
  get hasConditionalBlocks() {
    let conditionalBlocks = [];
    if (this.hasContent) {
      this.prosemirrorState.doc.content.forEach(t => {
        if (t.type === this.prosemirrorState.schema.nodes.ifElseStatement) {
          conditionalBlocks.push(t);
        }
      });
    }
    return conditionalBlocks.length > 0;
  }
  get isUploading() {
    return !!this.uploadManager && this.uploadManager.uploadsInProgress.length > 0;
  }
  selectionHasMark(markTypeName) {
    let markType = this.prosemirrorState.schema.marks[markTypeName];
    return selectionHasMark(this.prosemirrorState, markType);
  }
  get selectionIsEmpty() {
    return this.prosemirrorState.selection.empty;
  }
  get selectionIsCenterable() {
    return centerablesInSelection(this.prosemirrorState).length > 0;
  }
  get selectionAnchorNodeType() {
    return this.selectionAnchorNode?.type;
  }
  get selectionAnchorNodeTypeName() {
    return this.selectionAnchorNodeType?.name;
  }
  get selectedSection() {
    return findSelectedSection(this.prosemirrorState);
  }
  get selectedSectionType() {
    return this.selectedSection?.node.attrs.sectionType;
  }
  get selectionAnchorNode() {
    return findSelectionAnchorNode(this.prosemirrorState);
  }
  get selectionAnchorNodeDisplayWidth() {
    return this.selectionAnchorNode?.attrs.displayWidth;
  }
  get selectionAnchorNodeAlignment() {
    return this.selectionAnchorNode?.attrs.alignment;
  }
  get selectionAnchorNodeFontFamily() {
    return this.selectionAnchorNode?.attrs.fontFamily;
  }
  get selectionAnchorNodeFontColor() {
    return this.selectionAnchorNode?.attrs.fontColor;
  }
  get selectionAnchorNodeBackgroundColor() {
    return this.selectionAnchorNode?.attrs.backgroundColor;
  }
  get selectionAnchorNodePaddingTop() {
    return this.selectionAnchorNode?.attrs.paddingTop;
  }
  get selectionAnchorNodePaddingBottom() {
    return this.selectionAnchorNode?.attrs.paddingBottom;
  }
  get selectionAnchorNodePaddingLeft() {
    return this.selectionAnchorNode?.attrs.paddingLeft;
  }
  get selectionAnchorNodePaddingRight() {
    return this.selectionAnchorNode?.attrs.paddingRight;
  }
  get selectionAnchorNodeButtonStyle() {
    return this.selectionAnchorNode?.attrs.buttonStyle;
  }
  get selectionAnchorNodeButtonText() {
    return this.selectionAnchorNode?.attrs.text;
  }
  get selectionAnchorNodeButtonLink() {
    return this.selectionAnchorNode?.attrs.linkUrl;
  }
  get selectionAnchorNodeBorderRadius() {
    return this.selectionAnchorNode?.attrs.borderRadius;
  }
  get selectionAnchorNodeWidth() {
    return this.selectionAnchorNode?.attrs.width;
  }
  get selectionAnchorNodeBorderWidth() {
    return this.selectionAnchorNode?.attrs.borderWidth;
  }
  get selectionAnchorNodeBorderStyle() {
    return this.selectionAnchorNode?.attrs.borderStyle;
  }
  get selectionAnchorNodeBorderColor() {
    return this.selectionAnchorNode?.attrs.borderColor;
  }
  get sectionBackgroundColor() {
    return this.selectedSection?.node.attrs.backgroundColor;
  }
  get sectionPadding() {
    let tableCell = findSelectedTableCell(this.prosemirrorState);
    return tableCell?.node.attrs.paddingTop;
  }
  get tableStackedStatus() {
    let node = this.selectionAnchorNode;
    if (node.attrs.type !== 'table' || !node.attrs.responsive) {
      return undefined;
    }
    if (node.attrs.stacked === undefined || node.attrs.stacked === null) {
      return true;
    }
    return node.attrs.stacked;
  }
  get selectionIsLayout() {
    let node = this.selectionAnchorNode;
    return node.attrs.type === 'table' && node.attrs.responsive;
  }
  get selectedLayout() {
    let node = this.selectionAnchorNode;
    if (node.attrs.type !== 'table' || !node.attrs.responsive) {
      return undefined;
    }
    if (!node.firstChild) {
      return undefined;
    }
    let {
      selection
    } = this.prosemirrorState;
    return {
      node,
      pos: selection.$anchor.pos,
      depth: selection.$anchor.depth,
      start: selection.$anchor.pos + 1
    };
  }
  get selectedNodeHeight() {
    let node = this.selectionAnchorNode;
    return node.attrs.height;
  }
  get selectedNodeParentWidth() {
    let {
      selection
    } = this.prosemirrorState;
    let resolvedPosition = selection.$from;
    let domAtPosition = this.editorView.nodeDOM(resolvedPosition.pos);
    if (!domAtPosition) {
      return null;
    }
    let parent = domAtPosition.parentElement;
    let parentWidthString = getComputedStyle(parent).width;
    return parseInt(parentWidthString.slice(0, -2), 10);
  }
  get selectionIsInCollapsibleSectionSummary() {
    return !!this.currentlyActiveCollapsibleSectionSummary;
  }
  get selectionIsInCollapsibleSectionContent() {
    return !!this.currentlyActiveCollapsibleSectionContent;
  }
  get selectionIsInSingleBlock() {
    return this.prosemirrorState.selection.$from.parent === this.prosemirrorState.selection.$to.parent || this.prosemirrorState.selection instanceof NodeSelection;
  }
  get selectionIsOrderedList() {
    return this.currentlyActiveNestedList?.node.type === this.prosemirrorState.schema.nodes.orderedNestedList;
  }
  get selectionIsUnorderedList() {
    return this.currentlyActiveNestedList?.node.type === this.prosemirrorState.schema.nodes.unorderedNestedList;
  }
  get selectionIsHtml() {
    let selection = this.prosemirrorState.selection;
    if (!selection.node) {
      return false;
    }
    return selection.node.type === this.prosemirrorState.schema.nodes.html;
  }
  get dominantAlignmentIsLeft() {
    return this.isAlignmentDominant(ALIGNMENTS.left);
  }
  get dominantAlignmentIsCenter() {
    return this.isAlignmentDominant(ALIGNMENTS.center);
  }
  get dominantAlignmentIsRight() {
    return this.isAlignmentDominant(ALIGNMENTS.right);
  }
  get dominantAlignmentIsJustified() {
    return this.isAlignmentDominant(ALIGNMENTS.justify);
  }
  isAlignmentDominant(alignment) {
    let centerables = centerablesInSelection(this.prosemirrorState);
    return centerables.length > 0 && dominantAlignment(centerables) === alignment;
  }
  get hasSelectedText() {
    let state = this.prosemirrorState;
    let selection = state.selection;
    if (selection instanceof TextSelection) {
      return !selection.empty;
    }
    if (selection instanceof AllSelection) {
      let hasParagraph = false;
      state.doc.nodesBetween(selection.from, selection.to, node => {
        if (node.type === state.schema.nodes.paragraph) {
          hasParagraph = true;
        }
      });
      return hasParagraph;
    }
    return false;
  }
  get currentlyActiveTable() {
    return findTable(this.prosemirrorState.selection);
  }
  get currentlyActiveCell() {
    return isCellSelection(this.prosemirrorState.selection);
  }
  get currentlyActiveTableCell() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    return findParentNodeOfType(schema.nodes.tableCell)(selection);
  }
  get currentlyActiveCallout() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    return findParentNodeOfType(schema.nodes.callout)(selection);
  }
  get currentlyActiveCollapsibleSectionSummary() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    return findParentNodeOfType(schema.nodes.collapsibleSectionSummary)(selection);
  }
  get currentlyActiveCollapsibleSectionContent() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    return findParentNodeOfType(schema.nodes.collapsibleSectionContent)(selection);
  }
  get currentlyActiveNestedList() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    let nestedListNodes = [schema.nodes.unorderedNestedList, schema.nodes.orderedNestedList];
    return findParentNodeOfType(nestedListNodes)(selection);
  }
  get currentlyActiveSocial() {
    let {
      schema,
      selection
    } = this.prosemirrorState;
    return findParentNodeOfType(schema.nodes.social)(selection);
  }
  get selectionIsSocial() {
    return this.currentlyActiveSocial?.node.type === this.prosemirrorState.schema.nodes.social;
  }
  get selectionIsInNestedList() {
    return !!this.currentlyActiveNestedList;
  }
  get selectionIsInTable() {
    return !!this.currentlyActiveTable;
  }
  get selectionIsInContainer() {
    return this.currentlyActiveTable?.node.attrs.container;
  }
  get selectionIsInCallout() {
    return !!this.currentlyActiveCallout;
  }
  get selectionIsTableCell() {
    return !!this.currentlyActiveCell;
  }
  get undoDisabled() {
    return undoDepth(this.prosemirrorState) === 0;
  }
  get redoDisabled() {
    return redoDepth(this.prosemirrorState) === 0;
  }
  get currentAnchorPosition() {
    return this.prosemirrorState.selection.anchor;
  }
  get selectionNodeMarks() {
    return this.prosemirrorState.selection.$to.marks();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "prosemirrorState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "editorView", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectionInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hoverInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mouseIsDown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isInteractive", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isFormattable", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isSectionSelected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "showSectionType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "typeaheadState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _class);
export { State as default };